import { render, staticRenderFns } from "./FreeLine.vue?vue&type=template&id=4870e645&scoped=true"
import script from "./FreeLine.vue?vue&type=script&lang=ts"
export * from "./FreeLine.vue?vue&type=script&lang=ts"
import style0 from "./FreeLine.vue?vue&type=style&index=0&id=4870e645&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870e645",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4870e645')) {
      api.createRecord('4870e645', component.options)
    } else {
      api.reload('4870e645', component.options)
    }
    module.hot.accept("./FreeLine.vue?vue&type=template&id=4870e645&scoped=true", function () {
      api.rerender('4870e645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/FreeLine.vue"
export default component.exports